var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',[_c('div',{staticClass:"terms-content",on:{"click":_vm.showTermsAndConditions}},[_vm._v(" Terms and Conditions ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }